"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumStepName = void 0;
/**
 * The unique step name in a multi-step wizard that the event was sent from. This is also used as part of the event name for step view events.
 */
exports.EnumStepName = {
    ProfileSelect: 'ProfileSelect',
    InviteContactInfo: 'InviteContactInfo',
    InviteRoleSelection: 'InviteRoleSelection',
    InviteSmsConsent: 'InviteSmsConsent',
    InvitePhiConsent: 'InvitePhiConsent',
    NotMapped: 'NotMapped',
    ProvidingCareFor: 'ProvidingCareFor',
    RecipientDetails: 'RecipientDetails',
    RecipientRelationship: 'RecipientRelationship',
    ResentVerificationEmail: 'ResentVerificationEmail',
    SendVerificationEmail: 'SendVerificationEmail',
    SentVerificationEmail: 'SentVerificationEmail',
    SurveyIntro: 'SurveyIntro',
    SurveyQuestion: 'SurveyQuestion',
    SurveyOutro: 'SurveyOutro',
};
//# sourceMappingURL=enum-step-name.js.map